import { Typography } from "@material-ui/core";

export const LocationIcon = ({ color, onClick, width, style, text, textStyle }) => {
  return (
    <>
      <svg
        width={width || 32}
        height="42"
        viewBox="0 0 32 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
        style={style}
      >
        <path
          d="M24.2949 3.6988C19.3009 0.1004 12.7571 0.1004 7.76307 3.6988C-0.33065 9.75926 -1.19167 21.8802 5.35218 29.077L13.2737 39.8637C14.6514 41.3788 17.0623 41.3788 18.4399 39.8637L26.3614 29.077C33.2497 21.8802 32.3887 9.56987 24.2949 3.6988ZM16.029 23.0165C13.1015 23.0165 10.8628 20.5545 10.8628 17.3348C10.8628 14.1152 13.1015 11.6532 16.029 11.6532C18.9565 11.6532 21.1952 14.1152 21.1952 17.3348C21.1952 20.5545 18.9565 23.0165 16.029 23.0165Z"
          fill={color}
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {text ? (
        <Typography noWrap style={textStyle}>
          {text}
        </Typography>
      ) : null}
    </>
  );
};
